import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { EUserStatus, TUser } from '~/features/user/models'
import { queryKeys as userQueryKeys } from '~/features/user/utils'
import { EServerPath } from '~/models/api'
import HttpService from '~/services/http'

type TParams = {
  id: string
  lastLogin?: string
  adminOwned?: boolean
  name?: string
  status?: EUserStatus
}

type TUpdateUser = {
  params: TParams
  orgId?: string
  showToast?: boolean
}

const useUpdateUser = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: TUpdateUser) =>
      HttpService.put<TUser>({
        path: EServerPath.users,
        payload: payload.params,
      }),
    onSuccess(response, variables) {
      const orgId = response?.data?.orgId || variables?.orgId
      const userId = response?.data?.id || variables?.params?.id

      if (orgId) {
        queryClient.invalidateQueries({
          queryKey: userQueryKeys.userFromOrg(orgId),
        })
      }

      queryClient.invalidateQueries({
        queryKey: userQueryKeys.user(userId),
      })
    },
    onError: (_, variables) => {
      const showToast = variables?.showToast
      if (showToast) {
        toast.dismiss()
        toast.error("Couldn't update user, please try again later.")
      }
    },
  })
}

export default useUpdateUser
